import Markdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

export type MarkdownTextProps = {
  children?: string | null;
  /** Custom element renderers (e.g. legal-page tables). */
  components?: Components;
  /** Allow raw HTML in markdown — only for trusted CMS content. */
  allowHtml?: boolean;
  className?: string;
};

/** Renders markdown strings from CMS or other trusted sources. */
export function MarkdownText({
  children,
  components,
  allowHtml = false,
  className,
}: MarkdownTextProps) {
  if (children == null || children === '') return null;

  const markdown = (
    <Markdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={allowHtml ? [rehypeRaw] : undefined}
      components={components}
    >
      {children}
    </Markdown>
  );

  if (className) {
    return <div className={className}>{markdown}</div>;
  }

  return markdown;
}
